// extracted by mini-css-extract-plugin
export default {"error":"App__error--3X2"};